/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReplySummaryField,
    ReplySummaryFieldFromJSON,
    ReplySummaryFieldFromJSONTyped,
    ReplySummaryFieldToJSON,
    ReplySummaryStatus,
    ReplySummaryStatusFromJSON,
    ReplySummaryStatusFromJSONTyped,
    ReplySummaryStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReplySummary
 */
export interface ReplySummary {
    /**
     * 
     * @type {number}
     * @memberof ReplySummary
     */
    totalReplies?: number;
    /**
     * 
     * @type {number}
     * @memberof ReplySummary
     */
    unprocessedReplies?: number;
    /**
     * 
     * @type {Array<ReplySummaryStatus>}
     * @memberof ReplySummary
     */
    statuses?: Array<ReplySummaryStatus>;
    /**
     * 
     * @type {Array<ReplySummaryField>}
     * @memberof ReplySummary
     */
    fields?: Array<ReplySummaryField>;
}

export function ReplySummaryFromJSON(json: any): ReplySummary {
    return ReplySummaryFromJSONTyped(json, false);
}

export function ReplySummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplySummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalReplies': !exists(json, 'totalReplies') ? undefined : json['totalReplies'],
        'unprocessedReplies': !exists(json, 'unprocessedReplies') ? undefined : json['unprocessedReplies'],
        'statuses': !exists(json, 'statuses') ? undefined : ((json['statuses'] as Array<any>).map(ReplySummaryStatusFromJSON)),
        'fields': !exists(json, 'fields') ? undefined : ((json['fields'] as Array<any>).map(ReplySummaryFieldFromJSON)),
    };
}

export function ReplySummaryToJSON(value?: ReplySummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalReplies': value.totalReplies,
        'unprocessedReplies': value.unprocessedReplies,
        'statuses': value.statuses === undefined ? undefined : ((value.statuses as Array<any>).map(ReplySummaryStatusToJSON)),
        'fields': value.fields === undefined ? undefined : ((value.fields as Array<any>).map(ReplySummaryFieldToJSON)),
    };
}


